import { APIClient } from '../../infra/APIClient'
import { APIConfig, CursorPaged } from '../../types/definitions'
import {
  WorkspacePostingOpportunityDTO,
  WorkspaceInvitationDTO,
} from './dtos/workspace-posting-opportunity'
import {
  ListWorkspacePostingOpportunitiesQuery,
  ListWorkspacePostingInvitationsQuery,
} from './dtos/queries'

export function createWorkspacePostingOpportunitiesAPI(
  opts: APIConfig,
): WorkspacePostingOpportunitiesAPI {
  return new WorkspacePostingOpportunitiesAPI(opts)
}

export class WorkspacePostingOpportunitiesAPI extends APIClient {
  async listOpportunities(
    query: ListWorkspacePostingOpportunitiesQuery,
  ): Promise<CursorPaged<WorkspacePostingOpportunityDTO>> {
    return this.client
      .get(`/v3/postings/opportunities`, { params: query })
      .then(this._data)
  }

  async apply(id: string): Promise<void> {
    return this.client.patch(`/v3/postings/${id}/apply`).then(this._data)
  }

  async acceptInvitation(id: string): Promise<void> {
    return this.client.patch(`/v3/postings/${id}/accept`).then(this._data)
  }

  async rejectInvitation(id: string): Promise<void> {
    return this.client.patch(`/v3/postings/${id}/reject`).then(this._data)
  }

  async withdraw(id: string): Promise<void> {
    return this.client.patch(`/v3/postings/${id}/withdraw`).then(this._data)
  }

  async listInvitations(
    query: ListWorkspacePostingInvitationsQuery,
  ): Promise<CursorPaged<WorkspaceInvitationDTO>> {
    return this.client
      .get(`/v3/postings/invitations`, { params: query })
      .then(this._data)
  }
}
